// @flow
import { View } from 'reshaped';

import { Button } from '@gandi/reshaped';
import type { ButtonProps } from '@gandi/reshaped';

type Props = {
  secondaryButtonProps?: ButtonProps,
  primaryButtonProps: ButtonProps,
};

function getAttributesProps(props: ButtonProps): ButtonProps['attributes'] {
  if (!props.attributes)
    return {
      style: {
        flex: 1,
      },
    };

  // $FlowFixMe[incompatible-return]
  return {
    ...props.attributes,
    // $FlowFixMe[cannot-spread-indexer]
    style: {
      flex: 1,
      ...props.attributes.style,
    },
  };
}

export function ModalFooter({
  secondaryButtonProps,
  primaryButtonProps,
}: Props): React.MixedElement {
  return (
    <View
      as="div"
      gap={3}
      direction="row"
      position="sticky"
      backgroundColor="elevation-raised"
      paddingBlock={4}
      paddingInline={8}
      insetBottom={-7}
      bleed={8}
      attributes={{
        style: { marginBottom: 'calc(-1 * var(--rs-unit-x8))' },
      }}
    >
      {secondaryButtonProps && (
        <Button
          size="large"
          variant="outline"
          {...secondaryButtonProps}
          attributes={getAttributesProps(secondaryButtonProps)}
        >
          {secondaryButtonProps?.children}
        </Button>
      )}
      <Button
        fullWidth
        color="primary"
        size="large"
        {...primaryButtonProps}
        attributes={getAttributesProps(primaryButtonProps)}
      >
        {primaryButtonProps?.children}
      </Button>
    </View>
  );
}
